import { Editor } from "react-draft-wysiwyg";
import Styles from "./styles.module.scss";
import { InputTitle } from "@Molecule/InputField";

export default function SecondStep({ editorState, setEditorState, validate }) {
  return (
    <div className={Styles.container}>
      <InputTitle title={"Deskripsi Pekerjaan"} required={true} />
      <Editor
        editorState={editorState}
        onEditorStateChange={setEditorState}
        wrapperClassName={`${Styles.editorClassName} ${
          validate &&
          !editorState.getCurrentContent().getPlainText().trim() &&
          Styles.error
        }`}
        editorClassName={Styles.editor}
        toolbarClassName={Styles.toolbar}
        toolbar={{
          options: ["fontSize", "inline", "list"],
          inline: { options: ["bold", "italic", "underline"] },
          list: { options: ["unordered", "ordered"] },
          //   textAlign: { inDropdown: true },
          //   history: { inDropdown: true },
        }}
      />

      {validate && !editorState.getCurrentContent().getPlainText().trim() && (
        <span>*Deskripsi pekerjaan belum diisi</span>
      )}
    </div>
  );
}
